<template>
    <v-app id="smc-app">
        <v-app-bar id="smc-app-header" class="smc-app-bar" :class="isOrganization ? 'smc-app-bar-organization' : ''" height="70" absolute>
            <div class="app-bar-wrapper">
                <app-bar-navigation v-if="!hideNavigation" />
            </div>
        </v-app-bar>

        <!-- Sizes your content based upon application components -->
        <v-main
            class="background-image"
            :style="`background-image: url('${backgroundImage}')`"
        >
            <!-- Provides the application the proper gutter -->
            <v-container
                class="home-container"
                :class="$vuetify.breakpoint.xsOnly ? 'px-0' : ''"
            >
                <!-- If using vue-router -->
                <router-view />

                <div v-if="notifications && notifications.length > 0">
                    <v-alert
                        v-for="(notification, index) in notifications"
                        :key="notification.id"
                        class="toast-notification"
                        :class="`toast-notification-${index}`"
                        :color="notification.color"
                        @click="openRequest(notification)"
                    >
                        <v-card elevation="0">
                            <v-card-title class="pa-2">
                                <span>
                                    {{ notification.title }}
                                </span>
                                <span>
                                    {{ notification.smcReference }}
                                </span>
                                <v-icon small @click.stop="setNotificationRead(notification)">mdi-close</v-icon>
                            </v-card-title>
                            <v-card-text class="text-left px-2">
                                <div>
                                    <strong>
                                        {{ notification.vehicleName }}
                                    </strong>
                                    <span>
                                        {{ notification.message }}
                                    </span>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                {{ notification.timeDiff }}
                            </v-card-actions>
                        </v-card>
                    </v-alert>
                </div>

                <!--
                <contact-speed-dial
                    v-if="!isAuthenticated || !hasInnovationPolicy"
                />
                -->
            </v-container>
        </v-main>
        <site-footer v-if="showFooter" />
    </v-app>
</template>

<script>
import _ from 'lodash';
import AppBarNavigation from './components/app-bar-navigation';
import SiteFooter from './components/site-footer';
//import ContactSpeedDial from './components/widgets/contact-speed-dial';
import { dateHelper } from './helpers';

export default {
    name: 'app',
    components: {
        AppBarNavigation,
        SiteFooter,
        //ContactSpeedDial,
    },
    computed: {
        currentPage() {
            return this.$route.path;
        },
        backgroundImage() {
            if (_.startsWith(this.currentPage, '/about')) {
                return require('@/assets/images/background-images/road-transparent.png');
            }
            else if (_.startsWith(this.currentPage, '/contact')) {
                return require('@/assets/images/background-images/tire-transparent.png');
            }
            else if (_.startsWith(this.currentPage, '/account')) {
                return require('@/assets/images/background-images/gear-transparent.png');
            }
            else if (
                _.startsWith(this.currentPage, '/account/signup')
                || _.startsWith(this.currentPage, '/account/invite')
                || _.startsWith(this.currentPage, '/invite')
            ) {
                return require('@/assets/images/background-images/car-handle-transparent.png');
            }

            return '';
        },
        hideNavigation() {
            return process.env.VUE_APP_UNDER_MAINTENANCE === 'true';
        },
        isAuthenticated() {
            return this.$store.getters['user/isAuthenticated'];
        },
        isOrganization() {
            return this.$store.getters['user/isOrganization'];
        },
        organizationBranchId() {
            let organization = this.$store.getters['user/getOrganization'];
            if (organization && organization.organizationBranches && organization && organization.organizationBranches.length > 0) {
                return organization.organizationBranches[0].id;
            }
            return undefined;
        },
        hasInnovationPolicy() {
            return this.$store.getters['user/hasInnovationPolicy'];
        },
        notifications() {
            if (!this.isAuthenticated || !this.isOrganization) {
                return [];
            }

            let notifications = this.$store.getters['notifications/getNotifications'](this.organizationBranchId);
            return _.map(notifications, function (n) {
                return {
                    timeDiff: dateHelper.timeElapsed(n.dateCreatedUtc),
                    ...n,
                };
            });
        },
        showFooter() {
            return !this.currentPage.includes('/dashboard');
        },
    },
    watch: {
        contactSpeedDial(val) {
            this.contactSpeedDialTooltips = false;
            this.contactSpeedDialTooltipsDisabled = false;
            // delay the show of the tooltip, because showing it imedaitely means the FAB button animation is still running,
            // which causes the positioning of the tooltip label to be wrong.
            val
            && setTimeout(() => {
                this.contactSpeedDialTooltips = true;
                this.$nextTick(() => (this.contactSpeedDialTooltips = true));
            }, 250);
        },
    },
    mounted() {
        let pwaDismissCookie = this.$cookies.get('pwa_install_dismiss');
        window.addEventListener('beforeinstallprompt', e => {
            if (!pwaDismissCookie) {
                this.$store.dispatch('pwaInstall/storeInstallEvent', e);
            }
        });

        window.addEventListener('appinstalled', () => {
            this.$store.dispatch('pwaInstall/clearInstallEvent');
        });

        this.addZohoScript();
    },
    methods: {
        addZohoScript() {
            let scriptText1 = 'window.$zoho=window.$zoho || {}; \n';
            scriptText1 += '$zoho.salesiq=$zoho.salesiq || { \n';
            scriptText1 += 'ready: function () { \n';
            if (this.isAuthenticated) {
                scriptText1 += `$zoho.salesiq.visitor.name('${this.$store.getters['user/getEmail']}'); \n`;
                if (this.hasInnovationPolicy) {
                    let policyList = this.$store.getters['user/getInnovationPolicyList'];
                    scriptText1 += '$zoho.salesiq.visitor.info({';
                    for (let i = 0; i < policyList.length; i++) {
                        scriptText1 += `'Policy${i}':'${policyList[i]}'`;
                        if (i + 1 !== policyList.length) {
                            scriptText1 += ',';
                        }
                    }
                    scriptText1 += '}); \n';
                }
            }
            scriptText1 += '}} \n';

            let script1 = document.createElement('script');
            script1.innerHTML = scriptText1;
            
            let script2 = document.createElement('script');
            script2.setAttribute('id', 'zsiqscript');
            script2.setAttribute('src', 'https://salesiq.zohopublic.com/widget?wc=siqd58cb381c45a718d8d738a7d5d9a97bca35d396079739333ebc1eb48124698b7');
            script2.setAttribute('defer', true);

            document.head.append(script1);
            document.head.append(script2);
        },
        removeZohoScript() {
            let script = document.getElementById('zsiqchat');

            if (script) {
                document.head.removeChild(script);
            }
        },
        setNotificationRead(notification) {
            this.$store.dispatch('notifications/setNotificationRead', notification);
        },
        openRequest(notification) {
            this.$store.dispatch('notifications/setNotificationRead', notification);
            this.$router.push(`/quotes/${notification.quoteRequestId}`);
        },
    },
};
</script>

<style lang="scss">
@import "./assets/scss/app.scss";
@import "./assets/scss/vuetify-elements/app-bar.scss";

.v-sheet.alert-container {
  background: none;
  position: fixed;
  bottom: 70px;
  z-index: 4;
  padding: 0;
}
</style>
